import { Box, SimpleGrid } from "@chakra-ui/react";
import { useState, useMemo, useRef } from "react";
import { blogPosts } from "./blogData";
import SEO from "../../SEO";
import Pagination from "./Pagination";
import BlogCard from "./BlogCard";
import { BackgroundShapes } from "./BackgroundShapes";
import BlogHeader from "./BlogHeader";

const POSTS_PER_PAGE = 8;

const BlogPage = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const topRef = useRef<HTMLDivElement>(null);

  const totalPages = Math.ceil(blogPosts.length / POSTS_PER_PAGE);

  const paginatedPosts = useMemo(() => {
    const start = (currentPage - 1) * POSTS_PER_PAGE;
    return blogPosts.slice(start, start + POSTS_PER_PAGE);
  }, [currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    if (topRef.current) {
      topRef.current.scrollIntoView({ block: "start" });
    } else {
      window.scrollTo({ top: 0 });
    }
  };

  return (
    <>
      <SEO
        title="Wobble időpontfoglaló - blog cikkek vállalkozóknak a könnyebb online jelenlétért"
        description="Online jelenlét, időpontfoglaló, egyéni és csoportos események szervezése hatékonyan, erről írunk, ebben segítünk."
        keywords="blog, online megjelenés, kisvállalkozás, weboldal készítés, foglalási rendszer, időpontfoglaló"
        ogTitle="Wobble időpontfoglaló - blog cikkek vállalkozóknak a könnyebb online jelenlétért"
        ogDescription="Online jelenlét, időpontfoglaló, egyéni és csoportos események szervezése hatékonyan, erről írunk, ebben segítünk."
        ogImage="https://wobble.hu/assets/mockup_moov_studio.png"
      />

      <Box position="relative" bg="#F7FBFC" minH="100vh">
        <BackgroundShapes />

        <Box position="relative" zIndex={1} ref={topRef}>
          <BlogHeader />

          <Box maxW="6xl" mx="auto" p={{ base: 4, md: 8 }} mt={12}>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing={10}>
              {paginatedPosts.map((post) => (
                <BlogCard key={post.id} {...post} />
              ))}
            </SimpleGrid>

            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BlogPage;
